import { render, staticRenderFns } from "./SwitchValue.vue?vue&type=template&id=5d51968b&scoped=true"
import script from "./SwitchValue.vue?vue&type=script&lang=js"
export * from "./SwitchValue.vue?vue&type=script&lang=js"
import style0 from "./SwitchValue.vue?vue&type=style&index=0&id=5d51968b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51968b",
  null
  
)

export default component.exports